export default __webpack_public_path__ + "static/media/arg.9642ab73.jpg";